// extracted by css-extract-rspack-plugin
export default {"field":"k2KKD2KG8noTkiwb","label":"bIjANfFOe2YJOOgQ","datePicker":"EkfL4HX4o8E1hu51"};